import type { FlowStep } from '@/data'
import { getFunnelsURL } from '@/api/client'
import {
  defaultSteps as savingsEstimatesDefaults,
  validateSteps as validateSavingsEstimates,
} from './templates/SavingsEstimates/config'
import { defaultSteps as findingAssistanceDefaults } from './templates/FindingAssistance/config'
import {
  defaultSteps as gettingStartedDefaults,
  validateSteps as validateGettingStarted,
} from './templates/GettingStarted/config'

export interface HtmlTemplate {
  id: string
  name: string
  description: string
  previewImage: string
  previewUrl: string
  defaultState: FlowStep[]
}

export const htmlTemplates: HtmlTemplate[] = [
  {
    id: 'savings-estimates',
    name: 'Savings Estimates',
    description: 'Debt estimate funnel with debt question and form step',
    previewImage: '/images/templates/savings-estimates-template.png',
    previewUrl: `${getFunnelsURL()}/t/savings-estimates/`,
    defaultState: savingsEstimatesDefaults,
  },
  {
    id: 'finding-assistance',
    name: 'Finding Assistance',
    description:
      'Qualification funnel with debt question, qualification steps, verification, and form',
    previewImage: '/images/templates/finding-assistance-template.png',
    previewUrl: `${getFunnelsURL()}/t/finding-assistance/`,
    defaultState: findingAssistanceDefaults,
  },
  {
    id: 'getting-started',
    name: 'Getting Started',
    description:
      'Simple two-step lead capture funnel with contact info and verification details',
    previewImage: '/images/templates/getting-started-template.png',
    previewUrl: `${getFunnelsURL()}/t/getting-started/`,
    defaultState: gettingStartedDefaults,
  },
]

export function getDefaultState(templateSlug: string): FlowStep[] {
  const template = htmlTemplates.find((t) => t.id === templateSlug)
  return structuredClone(template?.defaultState ?? [])
}

export function getValidationErrors(
  templateSlug: string,
  steps: FlowStep[],
): string[] {
  switch (templateSlug) {
    case 'savings-estimates':
      return validateSavingsEstimates(steps)
    case 'getting-started':
      return validateGettingStarted(steps)
    default:
      return []
  }
}
